import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { IReportEmbedConfiguration, models, service, Embed, Report } from 'powerbi-client';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/shared/helper/util.service';



@Component({
  selector: 'app-view-analytics',  
  templateUrl: './view-analytics.component.html',
  styleUrl: './view-analytics.component.scss'
})
export class ViewAnalyticsComponent implements OnInit{



  reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: '',
    tokenType: models.TokenType.Embed,
    permissions: models.Permissions.All,
    viewMode: models.ViewMode.View,
    accessToken: '',
    settings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: true,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToPage
      }
    },
  };


  layoutSettings = {
    layoutType: models.LayoutType.Custom,
    customLayout: {
      displayOption: models.DisplayOption.FitToPage   
    },
  };

  @ViewChild(PowerBIReportEmbedComponent)
  reportObj!: PowerBIReportEmbedComponent;
  eventHandlersMap = new Map([
    [
      'loaded',
      () => {      
        console.log('Report is loaded');   
      },
    ],
    ['rendered', () => console.log('Report has rendered')],
    [
      'error',
      (event?: service.ICustomEvent<any>) => {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
    ['visualClicked', () => console.log('visual clicked')],
    ['pageChanged', (event) => ''],
  ]) as Map<
    string,
    (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null
  >;
  mode: any = 'View';
  accessToken: any;
  embeddedReport: Report;
  activeBtn: string = '';
  errorMessage: string = '';
  moduleId: any;
  isEditAllowed: boolean = false;
  reportName: string;

  @ViewChild('reportContainer') reportContainer: ElementRef;
  embedReports: any[];
  flagError: boolean = false;

  constructor(private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private util: UtilService,
  public router: Router) {}

  ngOnInit() {
    this.flagError = false;
    this.errorMessage = '';
    this.mode = 'View';
    this.embedReports = [];
    
    this.activatedRoute.paramMap.subscribe( (paramsMap: any) => {
      this.moduleId = paramsMap.get('moduleId');
      this.getAccessToken(this.moduleId); 
    });         
  }

  embedReport(reportId: string, embedUrl: string, accessToken: string){
     this.reportConfig = {
        ...this.reportConfig,
         accessToken: accessToken,
         id: reportId,
         embedUrl: embedUrl,
         settings: {
          panes: {
            filters: {
                expanded: false,
                visible: false
            }
        },
        background: models.BackgroundType.Transparent,
          filterPaneEnabled: false,
          navContentPaneEnabled: true,
          ...this.layoutSettings, // layout config
         } 
        };

      var reportContainer = document.getElementById('reportContainer');            
      this.embeddedReport = this.reportObj.powerbi.embed(reportContainer, this.reportConfig) as Report;  
      this.embeddedReport?.setComponentTitle('Embedded report');
      this.embeddedReport.resizeActivePage(4, window.innerHeight,window.innerWidth); 
  }


  getAccessToken(moduleId: any): any { 
    this.util.goToTop();
    const requestBody = {
      "moduleId": moduleId,
      "userId" : localStorage.getItem('userId')
    }     

    this.http.post<any>(`${environment.apiUrl}/v1/getEmbedInfo`, requestBody).subscribe({
      next: (res: any) => {
        const responseData = res;
        console.log(responseData);
        this.embedReports = [...responseData.embedReports];
        const embedReport = this.embedReports[0];
        this.isEditAllowed = responseData.isEditAllowed;
        this.reportName = embedReport.reportName;
        
        this.embedReport(embedReport.reportId, embedReport.embedUrl, responseData.accessToken);        
    },
    error : err =>{
      this.errorMessage = err;
      this.flagError = true;    
      
      this.util.SharingDataTextMessage.subscribe((res: any) => {
            this.errorMessage = res
          })
          setTimeout(() => { 
            this.flagError = false; 
            this.errorMessage = ''; 
            this.router.navigateByUrl('/all-analytics');
          }, 3000)        
      }
    });
  }
  
  toggleEdit(){
    this.activeBtn = 'Toggle Edit Mode';
    this.mode = this.mode == 'View' ? 'Edit' : 'View';
    this.embeddedReport.switchMode(this.mode);

    var showFilterPane = (this.mode == "Edit") ? true: false;
    this.embeddedReport.updateSettings({
      "filterPaneEnabled": showFilterPane
    });
  }

  fullSrceen(){
    this.activeBtn = 'Full Screen';
    this.embeddedReport.fullscreen();
  }

  print(){
    this.activeBtn = 'Print';
    this.embeddedReport.print();
  }

}
